import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-ikp-text-field',
  imports: [FormsModule, TranslatePipe],
  templateUrl: './text-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextFieldComponent {
  label = input.required<string>();
  value = input.required<string>();
  dataTestId = input.required<string>();
}
